import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetClassifiers } from './classifier.actions';
import { Classifier } from './classifier.model';

export interface ClassifierStateModel {
  classifiers?: Classifier[];
}

@State<ClassifierStateModel>({
  name: 'classifierStateModel',
})
@Injectable()
export class ClassifierState {
  @Selector() static classifiers(state: ClassifierStateModel) {
    return state.classifiers;
  }

  @Action(SetClassifiers) setClassifiers(
    ctx: StateContext<ClassifierStateModel>,
    { classifiers }: SetClassifiers,
  ) {
    ctx.patchState({ classifiers });
  }
}
